import { consoleTransport, logger } from "react-native-logs";
import { getConfig } from "./getConfig";

const severity = !getConfig("env") || getConfig("env") !== "prod" ? "debug" : "info";

export const log = logger.createLogger({
    severity,
    transport: consoleTransport,
    transportOptions: {
        colors: {
            info: "blueBright",
            warn: "yellowBright",
            error: "redBright",
            debug: "white",
        },
    },
});
